import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BreadCrumb } from "../components/BreadCrumb";

export const Contactanos = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState(() => {
    const savedData = location.state?.formData;
    if (savedData) {
      return savedData;
    } else {
      return {
        name: "",
        document: "",
        phone: "",
        email: "",
        comments: "",
      };
    }
  })

  const [errors, setErrors] = useState({})
  const maxCommentLength = 500

  const nameRef = useRef();
  const documentRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const commentsRef = useRef();

  const fieldLabels = {
    name: "Nombre y Apellido",
    document: "DNI, Pasaporte o RUC",
    phone: "Teléfono",
    email: "Correo electrónico",
    comments: "Comentarios",
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        if (!value.trim()) error = "El nombre es obligatorio";
        else if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/.test(value))
          error = "Solo se permiten letras y espacios";
        break;
      case "document":
        if (!value.trim()) error = "El documento es obligatorio";
        else if (value.length > 28) error = "Máximo 28 caracteres";
        break;
      case "phone":
        const onlyNums = value.replace(/\D/g, "");
        const localNumber = onlyNums.startsWith("51") ? onlyNums.slice(2) : onlyNums;

        if (localNumber.length !== 9) {
          error = "El teléfono debe tener 9 dígitos";
        } else if (!localNumber.startsWith("9")) {
          error = "El número debe comenzar con 9";
        }
        break;
      case "email":
        if (!value.trim()) error = "El correo es obligatorio";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Correo electrónico no válido";
        break;
      case "comments":
        if (!value.trim()) error = "Comentario es obligatorio";
        else if (value.length > maxCommentLength)
          error = `Máximo ${maxCommentLength} caracteres`;
        break;
      default:
        break;
    }
    return error;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handlePhoneChange = (phoneValue) => {
    setForm((prev) => ({ ...prev, phone: phoneValue }));

    const error = validateField("phone", phoneValue);
    setErrors((prev) => ({ ...prev, phone: error }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    Object.entries(form).forEach(([key, value]) => {
      const error = validateField(key, value);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const fieldRefs = {
        name: nameRef,
        document: documentRef,
        phone: phoneRef,
        email: emailRef,
        comments: commentsRef,
      };

      fieldRefs[firstErrorKey]?.current?.focus();

      return;
    }

    navigate("/gracias", { state: { formData: form } });
  };

  return (
    <div className="contactanos-page font-family-montserrat">
      <BreadCrumb
        productoNombre="Contacto"
        categoriaDescripcion={null}
        categoriaCodigo={null}
      />
      <div className="contactanos-header" style={{ marginTop: "30px" }}>
        <img
          src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=Group%2017.svg&version_id=null"
          alt="Contacto Icon"
          className="contacto-icon"
        />
        <h2 className="contacto-titulo">CONTÁCTANOS</h2>
      </div>

      <div className="contacto-form-container">
        <h3 className="form-titulo">FORMULARIO DE CONTACTO</h3>
        <p className="form-descripcion">
          Hola, para poder ayudarte, te pedimos que completes correctamente
          todos los campos solicitados en el siguiente formulario. Uno de
          nuestros ejecutivos de atención al cliente te contactará en un plazo
          de 24 horas hábiles. <br />
        </p>
        <p className="form-nota">
          Recuerda que siempre te puedes comunicar con nuestro canal de atención
          telefónica al +51 959 730 400 de lunes a viernes desde las 08:00 hasta
          las 17:30 hrs, excepto feriados/festivos.
        </p>

        <form className="contacto-form">
          <div className="form-grupo mrg-r-50">
            <label htmlFor="name">Nombre y Apellido*</label>
            <input
              required
              type="text"
              id="name"
              name="name"
              className="form-input"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && (
              <span className="error-message">{errors.name}</span>
            )}
          </div>

          <div className="form-grupo">
            <label htmlFor="document">DNI, PASAPORTE O RUC*</label>
            <input
              required
              type="text"
              id="document"
              name="document"
              className="form-input"
              value={form.document}
              onChange={handleChange}
            />
            {errors.document && (
              <span className="error-message">{errors.document}</span>
            )}
          </div>

          <div className="form-grupo mrg-r-50">
            <label htmlFor="phone">TELÉFONO*</label>
            <div className="phone-input-container">
              <PhoneInput
                required
                value={form.phone}
                onChange={handlePhoneChange}
                country={"pe"} // Código de país para Perú
                // onlyCountries={["pe"]} // Puedes agregar más países si es necesario
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: true,
                  className: "form-input form-input-contactanos",
                }}
              />
            </div>
            {errors.phone && (
              <span className="error-message">{errors.phone}</span>
            )}
          </div>

          <div className="form-grupo">
            <label htmlFor="email">E-mail*</label>
            <input
              required
              type="email"
              id="email"
              name="email"
              className="form-input"
              placeholder="Ejemplo: correo@gmail.com"
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <div className="form-grupo">
            <label htmlFor="comments">COMENTARIOS*</label>
            <textarea
              required
              id="comments"
              name="comments"
              className="form-input textarea-contactanos"
              rows="4"
              maxLength={maxCommentLength}
              value={form.comments}
              onChange={handleChange}
            />
            <div style={{ opacity: 0.6, fontSize: "13px" }}>
              {form.comments.length} / {maxCommentLength} caracteres
            </div>
            {errors.comments && (
              <span className="error-message">{errors.comments}</span>
            )}
          </div>
        </form>
        <div className="flex-container">
          <button type="submit" id="enviar-boton" onClick={handleSubmit}>
            ENVIAR
          </button>
        </div>
      </div>
    </div>
  );
};